import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonContainer, CastDetails, InnerContainer, ProjectDescTypo, ProjectNameTypo, StopCastingButton } from "./style";

const CastingDetails = () => {

    const navigate = useNavigate()
    const location = useLocation();
    const castDetails = location.state?.cast_detail;
    const url = castDetails?.link;

    const handleStop = () => {
        navigate("/");
    }

    return (
        <div>
            <div style={{ width: '100vw', height: '87vh' }}>
                <iframe
                    src={url}
                    title="Embedded URL"
                    width="100%"
                    height="100%"
                    allow="fullscreen"
                    style={{ border: 'none' }} 
                ></iframe>
            </div>
            <CastDetails>
                <InnerContainer>
                    <ProjectNameTypo>
                        {castDetails?.name}
                    </ProjectNameTypo>
                    <ProjectDescTypo>
                        {castDetails?.desc}
                    </ProjectDescTypo>
                </InnerContainer>
                <ButtonContainer>
                <StopCastingButton onClick={handleStop}>
                    Stop Casting
                </StopCastingButton>
                </ButtonContainer>
            </CastDetails>
        </div>
    )
}

export default CastingDetails;